<template>
  <div ref="subGlobal" class="global-main global-shadow">

    <div class='global-panel' v-loading.body="loading.index" style="padding: 10px">
      <div class="global-header">
        <div class="global-title">荣誉奖励</div>
        <div class='global-tbar'>
          <el-button size="small" type="danger"  @click="addAward()">新增</el-button>
          <el-select size="small" v-model="condition.type" placeholder="荣誉类别" clearable>
            <el-option v-for="item in awardTypeCombo" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
          <el-input size="small" v-model="condition.name" placeholder="荣誉称号"></el-input>
          <el-select size="small" v-model="condition.level" placeholder="荣誉级别" clearable>
            <el-option v-for="item in awardLevelCombo" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
          <el-select size="small" v-model="condition.rank" placeholder="奖励等级" clearable>
            <el-option v-for="item in awardRankCombo" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
          <el-input size="small" v-model="condition.bookName" placeholder="刊物名称"></el-input>
          <el-select size="small" v-model="condition.status" placeholder="状态" clearable>
            <el-option v-for="item in statusCombo" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
          <el-button size="small" type="primary"  @click="findByCondition()">检索</el-button>
        </div>
      </div>
      <hr>
      <div class='global-body'>
        <el-row>
          <el-col :span="18">
            <el-card shadow="hover" style="margin: 10px;">
              <el-table :data="awardList" border stripe style="width: 100%" size="mini" highlight-current-row @current-change="handleAwardChange">
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="type" label="类别" min-width="60" sortable></el-table-column>
                <el-table-column prop="name" label="称号" width="180"></el-table-column>
                <el-table-column prop="level" label="级别" width="70" sortable></el-table-column>
                <el-table-column prop="rank" label="等次" width="70" sortable></el-table-column>
                <el-table-column prop="bookName" label="刊物名称" min-width="100" sortable></el-table-column>
                <el-table-column prop="staffName" label="教职工" min-width="100"></el-table-column>
                <el-table-column prop="status" label="状态" width="80">
                  <template slot-scope="scope">
                    <el-tag v-show="scope.row.status==='未提交'" type="warning">{{scope.row.status}}</el-tag>
                    <el-tag v-show="scope.row.status==='待审核'">{{scope.row.status}}</el-tag>
                    <el-tag v-show="scope.row.status==='通过'" type="success">{{scope.row.status}}</el-tag>
                    <el-tag v-show="scope.row.status==='驳回'" type="danger">{{scope.row.status}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="140" align="center">
                  <template slot-scope="scope">
                    <el-button v-show="scope.row.status==='未提交' || scope.row.status==='驳回'" class="global-text-btn-success" size="small" type="text" @click="showAward(scope.row,false)" style="margin-left: 10px;">编辑</el-button>
                    <el-button v-show="scope.row.status==='未提交' || scope.row.status==='驳回'" class="global-text-btn-danger" size="small" type="text" @click="deleteAward(scope.row)">删除</el-button>
                    <el-button v-show="scope.row.status==='未提交'" class="global-text-btn-primary" size="small" type="text" @click="submitAward(scope.row)">提交</el-button>
                    <el-button v-show="scope.row.status==='待审核' || scope.row.status==='通过'" class="global-text-btn-success" size="small" type="text" @click="showAward(scope.row,true)">查看</el-button>
                    <el-button v-show="scope.row.status==='待审核' && ctrlType=='fill'" class="global-text-btn-warning" size="small" type="text" @click="cancelAward(scope.row,true)">撤回</el-button>
                    <el-button v-show="scope.row.status==='待审核' && ctrlType=='manage'" class="global-text-btn-success" size="small" type="text" @click="passAward(scope.row)">通过</el-button>
                    <el-button v-show="(scope.row.status==='待审核' || scope.row.status==='通过') && ctrlType=='manage'" class="global-text-btn-danger" size="small" type="text" @click="revertAward(scope.row)">驳回</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页  -->
              <div v-show="paging.allNum > paging.everySize" class="global-paging">
                <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover" style="margin: 10px;">
              <div class="global-header">
                <div class="global-title">附件</div>
                <div class='global-tbar'>
                  <el-upload :action="'rest/award/uploadAttach' "
                             :data="{awardId: currentRecord.id}"
                             multiple
                             :on-progress="uploadProgress"
                             :on-error="uploadError"
                             :on-success="uploadSuccess"
                             :show-file-list='false'
                             accept="*"
                             :disabled="!currentRecord.id">
                    <el-button type="primary" size="small" icon="el-icon-upload2" :disabled="!currentRecord.id">上传附件</el-button>
                  </el-upload>
                </div>
              </div>
              <el-table :data="attachList" style="width: 100%" row-key="id" border stripe size="mini" >
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column label="附件名" prop="fileName">
                  <template slot-scope="scope">
                    <!-- 如果是图片类型，显示图片 -->
                    <el-image
                      v-if="isImageType(scope.row)"      style="width: 100px; height: 100px"
                      :src="scope.row.url"
                      :preview-src-list="imgList"
                      @click="showImg(scope.row.url)">
                    </el-image>
                    <!-- 如果是其他类型，显示文件名 -->
                    <span v-else>
                      <a :href="scope.row.url" target="_blank" style="color: #409EFF; text-decoration: underline; cursor: pointer;">
                        {{ scope.row.fileName }}
                      </a>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center" fixed="right">
                  <template slot-scope="scope">
                    <el-button class="global-text-btn-danger" type="text" size="small" @click="deleteAwardAttach(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog :visible.sync="visible.editForm" width="400px" v-loading="loading.edit" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="awardForm" :model="currentRecord" label-width="80px" :rules="serverRules" size="small">
        <el-form-item label="荣誉类别" prop="type">
          <el-select v-model="currentRecord.type" placeholder="请选择" @change="loadAwardNamesByType">
            <el-option v-for="item in awardTypeCombo" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="荣誉称号" prop="name">
          <el-select v-model="currentRecord.name" placeholder="请选择">
            <el-option v-for="item in awardNameCombo" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="荣誉级别" prop="level" v-show="!isPaperOrPublicationType(currentRecord.type)">
          <el-select v-model="currentRecord.level" placeholder="请选择">
            <el-option v-for="item in awardLevelCombo" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="奖励等级" prop="rank" v-show="!isPaperOrPublicationType(currentRecord.type)">
          <el-select v-model="currentRecord.rank" placeholder="请选择">
            <el-option v-for="item in awardRankCombo" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="刊物名称" prop="bookName" v-show="isPaperOrPublicationType(currentRecord.type)">
          <el-input v-model="currentRecord.bookName"></el-input>
        </el-form-item>
        <el-form-item label="文章标题" prop="bookTitle" v-show="isPaperOrPublicationType(currentRecord.type)">
          <el-input v-model="currentRecord.bookTitle"></el-input>
        </el-form-item>
        <el-form-item label="构成" prop="consist">
          <el-select v-model="currentRecord.consist" placeholder="请选择">
            <el-option v-for="item in awardConsistCombo" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="教职工" prop="staffName">
          <el-select v-model="currentRecord.staffName" filterable placeholder="请选择" :disabled="ctrlType=='fill'">
            <el-option v-for="item in staffCombo" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="获奖时间" prop="awardTime">
          <el-date-picker v-model="currentRecord.awardTime" type="month" format="yyyy-MM" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="发证单位" prop="issuingPlace">
          <el-input v-model="currentRecord.issuingPlace"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input v-model="currentRecord.note" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-input v-model="currentRecord.status" readonly></el-input>
        </el-form-item>
        <el-form-item label="审核人" prop="auditor">
          <el-input v-model="currentRecord.auditor" readonly></el-input>
        </el-form-item>
        <el-form-item label="审核时间" prop="auditorTime">
          <el-input v-model="currentRecord.auditorTime" readonly></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="visible.editForm = false">取 消</el-button>
      <el-button v-show="!visible.readOnly" type="primary" @click="saveAward()">保 存</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'Award',
  data() {
    return {
      ctrlType: '',
      // 遮罩
      loading: {index: false, edit: false},
      // 可见
      visible: {editForm: false, readOnly:false},
      // 分页
      paging: {currPage: 1, everySize: 20, allNum: 0},
      // Combo
      awardNameCombo: [],
      awardTypeCombo: [],
      awardLevelCombo:[],
      awardRankCombo:[],
      awardConsistCombo:[],
      staffCombo:[],
      statusCombo:[],
      // 数据列表
      awardList: [],
      attachList: [],
      imgList:[],
      // 查询条件
      condition: {name:'', type:'', level:'', rank:'', status:''},
      // 当前记录
      currentRecord: {},
      // 校验规则
      serverRules: {
        name: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        type: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        level: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        rank: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        consist: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        staffName: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        bookName: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        bookTitle: [
          { required: true, message: '该项必填', trigger: 'change' }
        ]
      }
    }
  },
  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight - vm.$baize.frameTitleHeight) + 'px';
    vm.ctrlType = this.$route.params.ctrlType;
    vm.findCombo();
    vm.findByCondition();
  },
  beforeRouteUpdate (to, from, next) {
    next()
    this.ctrlType = this.$route.params.ctrlType;
    this.findCombo();
    this.findByCondition();
  },
  methods: {
    // 判断是否为论文与著作类
    isPaperOrPublicationType(type) {
      return type === '论文与著作类'; // 根据实际的类别名称调整
    },
    // 新增方法：根据荣誉类别获取荣誉称号
    loadAwardNamesByType(type) {
      var vm = this;
      // 清空当前荣誉称号选项
      vm.awardNameCombo = [];

      if (!type) {
        // 如果没有选择类别，则清空荣誉称号选项
        vm.currentRecord.name = null;
        return;
      }

      // 请求后台获取对应类别的荣誉称号
      vm.$http.get('rest/award/findNameByType', {
        params: {
          blank: false,
          type: type  // 添加过滤参数
        }
      }).then(response => {
        // 更新数据
        vm.awardNameCombo = response.body;

        // 如果当前选择的名称不在新列表中，则清空选择
        const nameExists = vm.awardNameCombo.some(item => item.value === vm.currentRecord.name);
        if (!nameExists) {
          vm.currentRecord.name = null;
        }
      }, response => {
        // 提示
        vm.$notify({
          position: 'bottom-right',
          type: 'error',
          message: '加载荣誉称号失败'
        });
        // 异常处理
        vm.$baize.handle(vm, response);
      });
    },
    findCombo: function () {
      var vm = this;
      // 请求后台
      vm.$http.get('rest/sys/combo/findCombo', {params: {className:"DICT_荣誉名称_NAME", blank:false}}).then(response => {
        // 更新数据
        vm.awardNameCombo = response.body;
      }, response => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
      // 请求后台
      vm.$http.get('rest/sys/combo/findCombo', {params: {className:"DICT_荣誉类别_NAME", blank:false}}).then(response => {
        // 更新数据
        vm.awardTypeCombo = response.body;
      }, response => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
      // 请求后台
      vm.$http.get('rest/sys/combo/findCombo', {params: {className:"DICT_荣誉级别_NAME", blank:false}}).then(response => {
        // 更新数据
        vm.awardLevelCombo = response.body;
      }, response => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
      // 请求后台
      vm.$http.get('rest/sys/combo/findCombo', {params: {className:"DICT_奖励等级_NAME", blank:false}}).then(response => {
        // 更新数据
        vm.awardRankCombo = response.body;
      }, response => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
      // 请求后台
      vm.$http.get('rest/sys/combo/findCombo', {params: {className:"DICT_奖励构成_NAME", blank:false}}).then(response => {
        // 更新数据
        vm.awardConsistCombo = response.body;
      }, response => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
      // 请求后台
      vm.$http.get('rest/commonCombo/staff?blank=false').then(response => {
        // 更新数据
        vm.staffCombo = response.body;
      }, response => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
      // 请求后台
      vm.$http.get('rest/commonCombo/approveStatus',{params: {blank:false}}).then(response => {
        // 更新数据
        vm.statusCombo = response.body;
      }, response => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
    },

    findByCondition: function (currentPage) {
      var vm = this;
      vm.awardList = [];
      vm.attachList = [];
      // 区分分页与查询
      if(currentPage){
        vm.paging.currPage = currentPage;
      } else {
        vm.paging.currPage = 1;
      }
      // 开启遮罩
      vm.loading.index = true;
      var params = vm.condition
      params.currPage = vm.paging.currPage
      params.everySize = vm.paging.everySize
      params.ctrlType = vm.ctrlType
      // 请求后台
      vm.$http.get('rest/award/findByCondition', {params: params}).then(response => {
        // 关闭遮罩
        vm.loading.index = false;
        // 更新数据
        vm.awardList = response.body.awardList;
        vm.paging = response.body.pagingBean;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.index = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },

    addAward: function () {
      var vm = this;
      vm.currentRecord = {id:null, name:null, type:null, level:null, rank:null, consist:null, staffName:null, awardTime:null, note:null};
      if(vm.ctrlType==='fill') {
        vm.currentRecord.staffName = '当前用户';
      }
      // 初始化荣誉称号选项为空
      vm.awardNameCombo = [];
      vm.visible.editForm = true;
    },

    showAward: function (record, readOnly) {
      var vm = this;
      vm.currentRecord = JSON.parse(JSON.stringify(record));
      vm.visible.editForm = true;
      vm.visible.readOnly = readOnly;

      // 根据已有类别加载荣誉称号
      if (record.type) {
        vm.loadAwardNamesByType(record.type);
      } else {
        vm.awardNameCombo = [];
      }
    },

    deleteAward: function (record) {
      var vm = this;
      vm.$confirm('确定要【删除】记录[' + record.name + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.delete('rest/award/delete', {params: {id:record.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          vm.findByCondition(vm.paging.currPage);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },

    saveAward: function () {
      var vm = this;

      // 动态调整校验规则
      if (vm.isPaperOrPublicationType(vm.currentRecord.type)) {
        // 论文与著作类：不需要级别和等级，但需要刊物名称和文章标题
        vm.serverRules.level[0].required = false;
        vm.serverRules.rank[0].required = false;
        vm.serverRules.bookName[0].required = true;
        vm.serverRules.bookTitle[0].required = true;
      } else {
        // 其他类别：需要级别和等级，但不需要刊物名称和文章标题
        vm.serverRules.level[0].required = true;
        vm.serverRules.rank[0].required = true;
        vm.serverRules.bookName[0].required = false;
        vm.serverRules.bookTitle[0].required = false;
      }

      // 校验
      vm.$refs['awardForm'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['awardForm'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        if (vm.currentRecord.awardTime) {
          vm.currentRecord.awardTime = vm.$baize.formatDateToString(new Date(vm.currentRecord.awardTime), 'yyyy-MM-dd HH:mm:ss');
        }
        vm.currentRecord.ctrlType = vm.ctrlType;
        vm.$http.post('rest/award/save', vm.currentRecord).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 关闭窗口
          vm.visible.editForm = false;
          // 刷新
          vm.findByCondition(vm.paging.currPage);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      });
    },

    submitAward: function (record) {
      var vm = this;
      // 开启遮罩
      vm.loading.index = true;
      // 请求后台
      vm.$http.post('rest/award/submit', null,{params: {id:record.id}}).then(function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 刷新
        vm.findByCondition(vm.paging.currPage);
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '提交成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '提交失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },

    passAward: function (record) {
      var vm = this;
      // 开启遮罩
      vm.loading.index = true;
      // 请求后台
      vm.$http.post('rest/award/pass', null,{params: {id:record.id}}).then(function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 刷新
        vm.findByCondition(vm.paging.currPage);
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '操作成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '操作失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    cancelAward: function (record) {
      var vm = this;
      // 开启遮罩
      vm.loading.index = true;
      // 请求后台
      vm.$http.post('rest/award/cancel', null,{params: {id:record.id}}).then(function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 刷新
        vm.findByCondition(vm.paging.currPage);
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '操作成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '操作失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    revertAward: function (record) {
      var vm = this;
      // 开启遮罩
      vm.loading.index = true;
      // 请求后台
      vm.$http.post('rest/award/revert', null, {params: {id:record.id}}).then(function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 刷新
        vm.findByCondition(vm.paging.currPage);
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '操作成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.index = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '操作失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },

    uploadProgress: function (event, file, fileList) {
      var vm = this;
      // 开启遮罩
      vm.loading.index = true;
    },
    uploadError: function (err, file, fileList) {
      var vm = this;
      // 关闭遮罩
      vm.loading.index = false;
      // 弹出错误信息
      this.$alert(JSON.parse(err.message).message, '警告', {
        confirmButtonText: '确定',
        type: 'error'
      });
    },
    uploadSuccess: function (res,file) {
      var vm = this;
      // 关闭遮罩
      vm.loading.index = false;
      // 提示
      vm.$notify({position: 'bottom-right', type: res.status, message: res.msg});
      vm.handleAwardChange(vm.currentRecord);
    },

    handleAwardChange: function (award) {
      var vm = this;
      vm.attachList = [];
      vm.currentRecord = award || {};
      if (award) {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.get('rest/award/findAttach', {params: {awardId: vm.currentRecord.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 刷新
          vm.attachList = response.body.attachList;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }
    },

    deleteAwardAttach: function (record) {
      var vm = this;
      vm.$confirm('确定要【删除】附件[' + record.fileName + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.delete('rest/award/deleteAttach', {params: {id:record.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          vm.handleAwardChange(vm.currentRecord);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },

    showImg(val) {
      var vm = this;
      var imgList = [];
      vm.attachList.forEach((item,index) => {
        imgList.push(item.url);
      });
      var index = imgList.indexOf(val);
      vm.imgList = imgList.slice(index).concat(imgList.slice(0,index));
    },
    // 判断是否为图片类型文件
    isImageType(attach) {
      // 可以根据 fileType 字段判断，或者根据文件扩展名判断
      if (attach.fileType) {
        return attach.fileType === '图片';
      }
      // 如果没有 fileType 字段，可以根据文件扩展名判断
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
      const ext = attach.fileName.split('.').pop().toLowerCase();
      return imageExtensions.includes(ext);
    }
  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}
.el-image-viewer__close {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/app/Award.vue